// extracted by mini-css-extract-plugin
export var shake = "_6-1";
export var toastCloseButton = "_6-0";